function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function customPagination(wrapper, items, itemPerPage, currentPage, pageURL, caretIcon, customerId) {
  const totalPage = Math.ceil(items / itemPerPage);
  if(!(totalPage > 1)) {
    if (!(currentPage > 1)) {
      wrapper.innerHTML = '';
    }
    return;
  }
  currentPage = currentPage > totalPage ? 1 : currentPage;
  function getPaginatePart(start, end, portion) {
    let part = [];
    if ((start - end) === 2) {
      part = portion === 'first' ? [start - 1] : [end + 1];
    } else if ((start - end) === 3) {
      part = portion === 'first' ? [start - 2, start - 1] : [end + 1, end + 2];
    } else if ((start - end) >= 4) {
      part = portion === 'first' ? ['...', start - 2, start - 1] : [end + 1, end + 2, '...'];
    }
    return part;
  }
  function paginateParts(currentPage, totalPage) {
    let parts = [
      ...getPaginatePart(currentPage, 1, 'first'),
      currentPage,
      ...getPaginatePart(totalPage, currentPage)
    ];
    currentPage !== 1 && parts.unshift(1);
    currentPage !== totalPage && parts.push(totalPage);
    currentPage !== parts[0] && parts.unshift('<');
    totalPage !== currentPage && parts.push('>');
    return parts;
  }
  let paginateNumbers = paginateParts(currentPage, totalPage);
  const addLink =(page)=> {
    let link;
    if(typeof page === 'number') {
      if (page !== currentPage) {
        link = `<a class="pagination__item link" href="${pageURL}?${customerId ? 'id=' + customerId + '&' : ''}showPage=${page}">${page}<a/>`;
      } else if (currentPage === page ) {
        link = `<a class="pagination__item pagination__item--current link" href="${pageURL}?${customerId ? 'id=' + customerId + '&' : ''}showPage=${page}">${page}<a/>`;
      }
    } else {
      if (page === '<') {
        link = `<a href="${pageURL}?${customerId ? 'id=' + customerId + '&' : ''}showPage=${currentPage-1}" class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce">
                  ${caretIcon}
                </a>`;
      } else if (page === '>') {
        link = `<a href="${pageURL}?${customerId ? 'id=' + customerId + '&' : ''}showPage=${currentPage+1}" class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce">
                  ${caretIcon}
                </a>`;
      } else {
        link = `<span class="pagination__item">${page}</span>`;
      }
    }
    return link;
  }
  wrapper.innerHTML = '';
  const addNumber = (i) => {
    const li = document.createElement('li');
    li.innerHTML = addLink(i);
    wrapper.appendChild(li);
  }
  for ( let i = 0; i < paginateNumbers.length; i++) {
    addNumber(paginateNumbers[i]);
  }
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
// remove overlay when hover on product card image
(function() {
  document.addEventListener('DOMContentLoaded', ()=> {
    document.querySelectorAll(
      '.card-wrapper'
      ).forEach(item => {
        if (item.querySelector('.hover-video')) {
          const cardInner = item.querySelector('.card__inner');
          cardInner.addEventListener('mouseover', () => {
            cardInner.style.opacity = "0.999";
          });
          cardInner.addEventListener('mouseout', () => {
            cardInner.style.opacity = "";
          });
        };
      }
    );
  })
})();

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class KineticModal extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;

    const overlay = document.querySelector('.kinetic-modal__overlay');

    const removeModalHandler = (modal) => {
      modal.classList.remove('kinetic-modal--show');
      if (modal.classList.contains('kinetic-modal--setperspective')) {
        document.documentElement.classList.remove('kinetic-modal--perspective');
      }

      if (document.querySelector(".kinetic-modal.kinetic-modal--show")) {
        let showModalElement = document.querySelector(".kinetic-modal.kinetic-modal--show");
        trapFocus(showModalElement, showModalElement.querySelector("button"));
      } else {
        removeTrapFocus(button);
      }
    };

    let modal = document.querySelector(this.getAttribute('data-kinetic-modal')),
    closeElems = modal.querySelectorAll('[data-dismiss="modal"]');

    const focusableElements = getFocusableElements(modal);

    button.addEventListener('click', function(ev) {
      ev.preventDefault();

      modal.classList.add('kinetic-modal--show');
      trapFocus(modal, focusableElements[0]);
      overlay.removeEventListener('click', () => { removeModalHandler(modal)} );
      overlay.addEventListener('click', () => { removeModalHandler(modal)} );
      trapFocus(modal, focusableElements[0]);

      if (button.classList.contains('kinetic-modal--setperspective')) {
        button.addEventListener('transitionend', () => {
          document.documentElement.classList.add('kinetic-modal--perspective');
        }, {once: true});
      }
    });

    closeElems.forEach((closeElem) => {
      closeElem.addEventListener('click', function(ev) {
        ev.stopPropagation();
        removeModalHandler(modal);
        removeTrapFocus(button);
      })
    });

  }
}
customElements.define('kinetic-modal', KineticModal);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
    if (this.dataset.mediaType === 'video') this.loadContent(false);
  }

  loadContent(focus = true) {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    // check slider component nested or not if nested we need to set name in parent component when we use it
    if(!this.getAttribute("name")) {
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');
    } else {
      this.prevButton = this.querySelector('button[name="parent-previous"]');
      this.nextButton = this.querySelector('button[name="parent-next"]');
    }

    this.seamlessLoop = this.getAttribute("data-loop");
    this.isSliderVertical = this.classList.contains('slider-vertical');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) {
      if(this.sliderItems.length <=1) {
        this.prevButton.setAttribute('disabled', 'disabled');
        this.nextButton.setAttribute('disabled', 'disabled');
        this.slideCenter();
      }
      return;
    }

    if (!this.isSliderVertical) {
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    } else {
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetTop - this.sliderItemsToShow[0].offsetTop;
      this.slidesPerPage = Math.floor((this.slider.clientHeight  - this.sliderItemsToShow[0].offsetTop) / this.sliderItemOffset);
    }

    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
    this.slideCenter();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if(this.seamlessLoop) {
      if (!this.isSliderVertical && this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
        this.prevButton.setAttribute('data-end', 'true');
        this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
          currentPage: this.sliderItemsToShow.length - 1,
          currentElement: this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
        }}));
      } else if (this.isSliderVertical && this.isSlideVisible(this.sliderItemsToShow[0])) {
        this.prevButton.setAttribute('data-end', 'true');
        this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
          currentPage: this.sliderItemsToShow.length - 1,
          currentElement: this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
        }}));
      } else {
        this.prevButton.removeAttribute('data-end');
      }
      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
          currentPage: 1,
          currentElement: this.sliderItemsToShow[1]
        }}));
        this.nextButton.setAttribute('data-end', 'true');
      } else {
        this.nextButton.removeAttribute('data-end');
      }
    } else {
      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }
      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
  }

  // make slider center when not any slidable item
  slideCenter() {
    if(this.getAttribute("data-center")) {
      const prevButton = this.prevButton.getAttribute('disabled') === 'disabled';
      const nextButton = this.nextButton.getAttribute('disabled') === 'disabled';
      if (prevButton && nextButton ) {
        this.slider.style.justifyContent = "center";
      }
    }
  }

  isSlideVisible(element, offset = 0) {
    if (!this.isSliderVertical) {
      const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
      return element.offsetLeft <= (element.offsetLeft + element.clientWidth) && (element.offsetLeft + element.clientWidth) <= lastVisibleSlide + 10;
    } else {
      const lastVisibleSlide = this.slider.clientHeight + this.slider.scrollTop - offset;
      return (element.offsetTop + element.clientHeight) <= lastVisibleSlide && element.offsetTop >= this.slider.scrollTop;
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    if (!this.isSliderVertical) {
      if(!event.currentTarget.dataset.end) {
        this.slideScrollPosition = event.currentTarget.name.includes('next') ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
        this.slider.scrollTo({
          left: this.slideScrollPosition
        });
      } else {
        this.slideScrollPosition = (
          event.currentTarget.name === 'next' ? 0 : this.slider.scrollWidth - this.slider.clientWidth
        );
        this.slider.scrollTo({
          left: this.slideScrollPosition
        });
      }
    } else {
      if(!event.currentTarget.dataset.end) {
        this.slideScrollPosition = event.currentTarget.name.includes('next') ? this.slider.scrollTop + (step * this.sliderItemOffset) : this.slider.scrollTop - (step * this.sliderItemOffset);
        this.slider.scrollTo({
          top: this.slideScrollPosition
        });
      } else {
        this.slideScrollPosition = (
          event.currentTarget.name === 'next' ? 0 : this.slider.scrollHeight  - this.slider.clientHeight
        );
        this.slider.scrollTo({
          top: this.slideScrollPosition
        });
      }
    }
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();
    this.lastPosition = null;
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
    if (this.currentPage === this.sliderItems.length) {
      this.currentPage = 0;
    }
    this.currentPage += 1;
  }

  restartSlide() {
    let prevPosition = window.innerWidth - this.sliderItems[this.sliderItems.length - 1].getBoundingClientRect().right;
    if(this.lastPosition == prevPosition) {
      this.slider.scrollTo({
        left: 0
      });
    } else {
      this.lastPosition = prevPosition;
    }
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    if (window.location.href.includes('preview_key')) {
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', this.currentVariant.id);
        window.location.href = url.toString();
      } catch (error) {
        console.error('Error updating URL with variant:', error);
      }
    }
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const selectedElement = html.querySelector('product-form button');
        const oldAddButton = document.querySelector('product-form button');
        if (selectedElement && oldAddButton) {
          oldAddButton.parentNode.replaceChild(selectedElement, oldAddButton);
        }
        Currency.convertAll(shopCurrency, Currency.currentCurrency);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class CustomAccordion extends HTMLElement {
  constructor() {
    super();
    this.accordion = this.querySelector('[id^="accordion__"]');
    this.accordion.addEventListener('click', this.onButtonClick.bind(this));
  }

  closeOthers(skipItem) {
    const accordionItems = this.accordion.querySelectorAll('li.custom-accordion button.open');
    accordionItems.forEach((item) => {
      if (item.getAttribute('id') !== skipItem) {
        this.handleCollapse(item);
      }
    });
  }

  handleCollapse(button) {
    const textContent = button.nextElementSibling;
    if (!textContent) return;

    button.classList.toggle('open');
    textContent.classList.toggle('open');

    const height = textContent.children[0].offsetHeight;
    const maxHeight = textContent.classList.contains('open') ? `${height}px` : '0px';
    
    button.setAttribute(
      'aria-expanded',
      `${textContent.classList.contains('open') ? true : false}`
    );
    textContent.style.maxHeight = maxHeight;
  }

  onButtonClick(event) {
    const target = event.target.closest("button");
    if (!target) return;

    this.closeOthers(target.getAttribute('id'));
    
    this.handleCollapse(target);
  }
}

customElements.define('custom-accordion', CustomAccordion);

/* ================ Sparkling Cursor ================ */
const cursor = (() => {
  const mediumUpQuery = '(min-width: 990px)';
  let mql = window.matchMedia(mediumUpQuery);
  // let color="random"; // in addition to "random" can be set to any valid color eg "#f0f" or "red"
  let color = "#190049";
  if (window.location.pathname === "/pages/nightmare-christmas") {
    color = "#FFF";
  }
  let sparkles = 120;
  /****************************
   *  Tinkerbell Magic Sparkle *
   *(c)2005-13 mf2fm web-design*
   *  http://www.mf2fm.com/rv  *
   * DON'T EDIT BELOW THIS BOX *
   ****************************/
  let x = (ox = 400);
  let y = (oy = 300);
  let swide = 800;
  let shigh = 600;
  let sleft = (sdown = 0);
  let tiny = new Array();
  let star = new Array();
  let starv = new Array();
  let starx = new Array();
  let stary = new Array();
  let tinyx = new Array();
  let tinyy = new Array();
  let tinyv = new Array();
  const init = () => {
    if (document.getElementById) {
      for (let i = 0; i < sparkles; i++) {
        let rats = createDiv(3, 3);
        rats.style.visibility = "hidden";
        rats.style.zIndex = "999999";
        document.body.appendChild((tiny[i] = rats));
        starv[i] = 0;
        tinyv[i] = 0;
        rats = createDiv(5, 5);
        rats.style.backgroundColor = "transparent";
        rats.style.visibility = "hidden";
        rats.style.zIndex = "999999";
        let rlef = createDiv(1, 5);
        let rdow = createDiv(5, 1);
        rats.appendChild(rlef);
        rats.appendChild(rdow);
        rlef.style.top = "2px";
        rlef.style.left = "0px";
        rdow.style.top = "0px";
        rdow.style.left = "2px";
        document.body.appendChild((star[i] = rats));
      }
      set_width();
      sparkle();
    }
  };
  const sparkle = () => {
    let c;
    if (Math.abs(x - ox) > 1 || Math.abs(y - oy) > 1) {
      ox = x;
      oy = y;
      for (c = 0; c < sparkles; c++)
        if (!starv[c]) {
          star[c].style.left = (starx[c] = x) + "px";
          star[c].style.top = (stary[c] = y + 1) + "px";
          star[c].style.clip = "rect(0px, 5px, 5px, 0px)";
          star[c].childNodes[0].style.backgroundColor = star[
            c
          ].childNodes[1].style.backgroundColor =
            color == "random" ? newColor() : color;
          star[c].style.visibility = "visible";
          starv[c] = 50;
          break;
        }
    }
    for (c = 0; c < sparkles; c++) {
      if (starv[c]) update_star(c);
      if (tinyv[c]) update_tiny(c);
    }
    setTimeout(() => {
      sparkle();
    }, 40);
  };
  const update_star = (i) => {
    if (--starv[i] == 25) star[i].style.clip = "rect(1px, 4px, 4px, 1px)";
    if (starv[i]) {
      stary[i] += 1 + Math.random() * 3;
      starx[i] += ((i % 5) - 2) / 5;
      if (stary[i] < shigh + sdown) {
        star[i].style.top = stary[i] + "px";
        star[i].style.left = starx[i] + "px";
      } else {
        star[i].style.visibility = "hidden";
        starv[i] = 0;
        return;
      }
    } else {
      tinyv[i] = 50;
      tiny[i].style.top = (tinyy[i] = stary[i]) + "px";
      tiny[i].style.left = (tinyx[i] = starx[i]) + "px";
      tiny[i].style.width = "2px";
      tiny[i].style.height = "2px";
      tiny[i].style.backgroundColor =
        star[i].childNodes[0].style.backgroundColor;
      star[i].style.visibility = "hidden";
      tiny[i].style.visibility = "visible";
    }
  };
  const update_tiny = (i) => {
    if (--tinyv[i] == 25) {
      tiny[i].style.width = "1px";
      tiny[i].style.height = "1px";
    }
    if (tinyv[i]) {
      tinyy[i] += 1 + Math.random() * 3;
      tinyx[i] += ((i % 5) - 2) / 5;
      if (tinyy[i] < shigh + sdown) {
        tiny[i].style.top = tinyy[i] + "px";
        tiny[i].style.left = tinyx[i] + "px";
      } else {
        tiny[i].style.visibility = "hidden";
        tinyv[i] = 0;
        return;
      }
    } else tiny[i].style.visibility = "hidden";
  };

  const createDiv = (height, width) => {
    let div = document.createElement("div");
    div.style.position = "absolute";
    div.style.height = height + "px";
    div.style.width = width + "px";
    div.style.overflow = "hidden";
    div.style.pointerEvents = "none";
    return div;
  };
  const newColor = () => {
    let c = new Array();
    c[0] = 255;
    c[1] = Math.floor(Math.random() * 256);
    c[2] = Math.floor(Math.random() * (256 - c[1] / 2));
    c.sort(function () {
      return 0.5 - Math.random();
    });
    return "rgb(" + c[0] + ", " + c[1] + ", " + c[2] + ")";
  };
  const mouse = (e) => {
    if (e) {
      y = e.pageY;
      x = e.pageX;
    } else {
      set_scroll();
      y = e.y + sdown;
      x = e.x + sleft;
    }
  };
  document.onmousemove = mouse;
  const set_scroll = () => {
    if (typeof self.pageYOffset == "number") {
      sdown = self.pageYOffset;
      sleft = self.pageXOffset;
    } else if (
      document.body &&
      (document.body.scrollTop || document.body.scrollLeft)
    ) {
      sdown = document.body.scrollTop;
      sleft = document.body.scrollLeft;
    } else if (
      document.documentElement &&
      (document.documentElement.scrollTop ||
        document.documentElement.scrollLeft)
    ) {
      sleft = document.documentElement.scrollLeft;
      sdown = document.documentElement.scrollTop;
    } else {
      sdown = 0;
      sleft = 0;
    }
  };
  window.onscroll = set_scroll;
  const set_width = () => {
    let sw_min = 999999;
    let sh_min = 999999;
    if (document.documentElement && document.documentElement.clientWidth) {
      if (document.documentElement.clientWidth > 0)
        sw_min = document.documentElement.clientWidth;
      if (document.documentElement.clientHeight > 0)
        sh_min = document.documentElement.clientHeight;
    }
    if (typeof self.innerWidth == "number" && self.innerWidth) {
      if (self.innerWidth > 0 && self.innerWidth < sw_min)
        sw_min = self.innerWidth;
      if (self.innerHeight > 0 && self.innerHeight < sh_min)
        sh_min = self.innerHeight;
    }
    if (document.body.clientWidth) {
      if (document.body.clientWidth > 0 && document.body.clientWidth < sw_min)
        sw_min = document.body.clientWidth;
      if (document.body.clientHeight > 0 && document.body.clientHeight < sh_min)
        sh_min = document.body.clientHeight;
    }
    if (sw_min == 999999 || sh_min == 999999) {
      sw_min = 800;
      sh_min = 600;
    }
    swide = sw_min;
    shigh = sh_min;
  };
  window.onresize = set_width;

  const initBreakpoints = () => {
    if (mql.matches) {
      if (document.readyState !== "loading") init();
      else document.addEventListener("DOMContentLoaded", init);
    }
  };
  try {
    document.addEventListener("DOMContentLoaded", initBreakpoints);
  } catch (e) {
    console.error(e);
  }
})();

document.addEventListener('DOMContentLoaded', function () {
  const socialSharing = document.querySelectorAll('.social-sharing');
  socialSharing.forEach(item => {
    const itemParent = item.parentNode;
    const itemSocialSharing = itemParent.querySelector('.social-sharing');
    itemParent.addEventListener('click', function () {
      if(itemSocialSharing.classList.contains('open-social-sharing')) {
        document.querySelector('.social-sharing.open-social-sharing').style.left = 0;
        itemSocialSharing.classList.remove('open-social-sharing');
      } else {
        itemSocialSharing.classList.add('open-social-sharing');
        function getAvailableWidth() {
          let rightAvailableWidth= window.innerWidth - document.querySelector('.social-sharing.open-social-sharing').getBoundingClientRect().right;
          if(rightAvailableWidth < 121) {
            return 120 - rightAvailableWidth
          };
        }
        if(itemParent.parentNode.classList.contains('share-button__container')) {
          document.querySelector('.social-sharing.open-social-sharing').style.left = '-50px';
        } else {
          let width = getAvailableWidth();
          if(width > 0) {
            document.querySelector('.social-sharing.open-social-sharing').style.left = `-${width}px`;
            if(width > 50 && width < 100) {
              document.querySelector('.social-sharing.open-social-sharing').classList.add('width-fiftty');
            }
            if(width > 100) {
              document.querySelector('.social-sharing.open-social-sharing').classList.add('width-hundred');
            }
          }
        }
      }
    });
  });
  window.onclick = function (e) {
    if(!e.target.parentNode.matches('.social-sharing__container, .share, .icon__share')) {
      socialSharing.forEach(item => {
        const itemParent = item.parentNode;
        const itemSocialSharing = itemParent.querySelector('.social-sharing');
        if(itemSocialSharing.classList.contains('open-social-sharing')) {
          document.querySelector('.social-sharing.open-social-sharing').style.left = 0;
          itemSocialSharing.classList.remove('open-social-sharing');
        }
      });
    };
  };
});

document.addEventListener('DOMContentLoaded', function () {
  const copyText = document.querySelectorAll('.copy-to-clipboard');
  copyText.forEach(item => {
    item.addEventListener('click', function () {
      navigator.clipboard.writeText(item.value);
    });
  });
});